// @flow
import React, { type Node } from 'react';

import { COLORS } from 'Components/utils/color/colors';

import { Text } from 'Components/frameworks/text/Text.jsx';
import { Title } from 'Components/frameworks/title/Title.jsx';

export type ProductFeatureDetailMainInformationProps = {
  className?: string,
  color?: Colors,
  duration?: {
    description: string,
    label?: string,
  },
  items?: Array<{
    description?: string,
    label?: string,
    note?: string,
  }>,
  note?: string,
  smallTitle?: Node,
  title?: string,
};

export function ProductFeatureDetailMainInformation(
  props: ProductFeatureDetailMainInformationProps,
) {
  const {
    className,
    color = COLORS.GRAY_DARKER,
    duration = {},
    items = [],
    note,
    smallTitle,
    title,
  } = props;

  if (!duration.description && !items.length) {
    return null;
  }

  return (
    <section className={className}>
      <Title className="mb-5 sm:mb-4" color={color} hLevel={3} theme="title-brand-5">
        {smallTitle ? (
          <span className="flex flex-col sm:flex-row sm:justify-between w-full">
            {title} {smallTitle}
          </span>
        ) : (
          title
        )}
      </Title>
      <div className="rtl:pr-2 w-full sm:w-1/2">
        {!!duration.description && (
          <div className="text-1 mt-3 mb-3">
            {!!duration.label && <span className="font-bold">{`${duration.label}: `}</span>}
            {duration.description}
          </div>
        )}
        {!!items.length && (
          <ul className="list-none p-0 leading-normal text-base text-gray-darker">
            {items.map(item => {
              return (
                (item.description || item.note) && (
                  <li className="my-1 py-2 list-disc" key={item.label}>
                    {!!item.label && <div className="font-bold">{item.label}</div>}
                    {!!item.description && (
                      <Text className="inline-block mb-1" text={item.description} />
                    )}
                    {!!item.note && <small className="block">{item.note}</small>}
                  </li>
                )
              );
            })}
          </ul>
        )}
        {!!note && <div className="italic mt-4 text-sm">{note}</div>}
      </div>
    </section>
  );
}
